/**
 * Centralized status-to-Badge-variant mappings.
 * Import the relevant map and use it as: <Badge variant={map[status]}>
 */

export const tournamentStatusVariant = {
  open: 'teal',
  live: 'teal',
  upcoming: 'blue',
  draft: 'orange',
  locked: 'muted',
  complete: 'muted',
  past: 'muted',
  closed: 'muted',
}

export const userStatusVariant = {
  active: 'teal',
  suspended: 'magenta',
}

export const roleVariant = {
  admin: 'solid-purple',
  owner: 'secondary',
  member: 'secondary',
  user: 'secondary',
}
